import { NeoModel, ValueObject } from "@singularsystems/neo-core";

@NeoModel
export default class CheckQuerySummarySearchCriteria extends ValueObject {
    
    public searchCriteria: string = "";
}